import React from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import MUIDataTable from 'mui-datatables';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Toggle from 'react-toggle';
// import {
// 	FormGroup,
// 	FormLabel,
// 	Tooltip,
// 	TextField,
// 	Button,
// 	Select,
// 	FormControl,
// 	InputLabel,
// } from '@material-ui/core';
import $ from 'jquery'
import { getAllProductParts } from '../../actions/homeAction';
import { createMuiTheme } from '@material-ui/core/styles';
// import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';

class ProductListTable extends React.Component {
	getMuiTheme = () =>
		createMuiTheme({
			overrides: {
				MUIDataTable: {
					responsiveStacked: {
						maxHeight: '35vh',
						overflowX: 'none',
					},
				},
				MUIDataTableHeadCell: {
					root: {
						width: '80px',
						fontWeight: 'bold',
						padding: '5px',
						lineHeight: '10px',
						whiteSpace: 'normal',
						overflow: 'hidden',
						//           wordWrap: "break-word",
						fontSize: '10px',
					},
				},
				MUIDataTableBodyCell: {
					root: {
						width: '80px',
						fontSize: '9px', // border:'1px solid black',
						padding: '5px',
						whiteSpace: 'normal',
						wordWrap: 'break-word',
					},
				},
			},
		});
	// constructor() {
	// 	super();
	// 	this.state = {};
	// }
	state = { list: [] };
	handleStatusChange = sid => {
		var isChecked = $('#cattogBtn_' + sid);
		isChecked.prop('checked', !isChecked.prop('checked'));
		console.log(isChecked.prop('checked'), !isChecked.prop('checked'));
		if (!isChecked.prop('checked') === true) {
			var status = 'active';
		} else {
			var status = 'inactive';
		}
		let newArray = this.state.user_list;
		var a = newArray.find(element => {
			return element.id === sid;
		});
		a.status = status;
		console.log(newArray);
		this.setState({ user_list: newArray });
		Swal.fire('Update Status!', 'Status has been updated.', 'success');
	};

	componentDidUpdate(prevProps) {
		console.log('hello 1', prevProps);

		if (prevProps.location.pathname !== this.props.location.pathname) {
			console.log('hello 2');
			if (this.props.match.params.type === 'countryCode') {
				this.setState({
					user_list: [{ ServiceType: 'country code' }, { ServiceType: 'code' }],
				});
			} else if (this.props.match.params.type === 'CountryList') {
				console.log('under spare part');
				this.setState({
					user_list: [{ ServiceType: 'country list' }, { ServiceType: 'list' }],
				});
			} else if (this.props.match.params.type) {
			}
		}
	}

	componentDidMount() {
		this.props.getAllProductParts();
	}

	render() {
		let columns = [];

		columns = [
			{
				name: 'name',
				label: 'Product Name (En)',
				options: {
					filter: false,
					sort: true,
				},
			},
			{
				name: 'nameAr',
				label: 'Product Name (Ar)',
				options: {
					filter: false,
					sort: true,
				},
			},

			{
				name: 'media',
				label: 'Image',
				options: {
					filter: false,
					sort: false,
					customBodyRender: (media, tableMeta) => {
						return (
							<img
								src={
									media !== undefined && media !== null 
										? media.path !== undefined &&
										  media.path !== null &&
										  media.path !== ''
											? media.path
											: './assets/images/icon.png'
										: './assets/images/icon.png'
								}
								className='img-fluid img-60'
								alt=''
								onError={this.imgLoadError}
							/>
						);
					},
				},
			},

			// {
			// 	name: 'priority',
			// 	label: 'Priority ',
			// 	options: {
			// 		filter: false,

			// 		customBodyRender: (priority, tableMeta) => {
			// 			console.log('thsi is table', tableMeta);
			// 			return <span>{tableMeta.rowData[2]}</span>;
			// 		},
			// 	},
			// },

			// {
			// 	name: '	priority',
			// 	label: 'Priority ',
			// 	options: {
			// 		filter: false,
			// 		sort: true,
			// 	},
			// },

			{
				name: 'status',
				label: 'Status',
				options: {
					filter: true,
					sort: true,
					customBodyRender: (status, tableMeta) => {
						var Id = tableMeta.rowData[4];
						// console.log(tableMeta.rowData[6]);
						return (
							<Toggle
								id={'status_' + Id}
								checked={status}
								value={status}
								onChange={this.handleStatusChange.bind(this, Id, status)}
							/>
						);
					},
				},
			},
		];

		const options = {
			filter: false,
			viewColumns: false,
			print: false,
			download: false,
			selectableRows: 'none',
			textLabels: {
				body: {
					noMatch: this.state.isSaving
						? 'Loading data..!'
						: 'Sorry, No Users Found',
					toolTip: 'Sort',
					columnHeaderTooltip: column => `Sort for ${column.label}`,
				},
			},
		};
		return (
			<div className='pcoded-inner-content'>
				<div className='main-body'>
					<div className='page-wrapper'>
						<div className='row'>
							<div className='col-sm-12'>
								<div className='card'>
									<div className='card-header'>
										{/* <h5>Product {this.props.match.params.type} List</h5> */}
										<Link
											to={`/ProductMaster/AddProductMaster`}
											className='btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger'
											data-modal='modal-13'>
											{' '}
											<i className='icofont icofont-plus m-r-5'></i>
											Add Product Master
										</Link>
									</div>

									<div className='card-block'>
										<div className='dt-responsive table-responsive'>
											{/* <button
												className='f-right bg-white b-none'
												data-modal='modal-13'>
												<Tooltip
													title='Download Selected'
													aria-label='download'
													onClick={() => {
														this.exportCSVS();
													}}>
													<i
														className='icofont icofont-download-alt'
														style={{
															fontSize: '30px',
															color: 'grey',
														}}></i>
												</Tooltip>
											</button> */}

											{/* <MuiThemeProvider theme={this.getMuiTheme()}> */}
											{this.props.ProductList !== undefined ? (
												<MUIDataTable
													title={`Product Master List`}
													className='table-responsive'
													data={this.props.ProductList}
													columns={columns}
													options={options}
												/>
											) : (
												<h4>Loading...</h4>
											)}
											{/* </MuiThemeProvider> */}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

ProductListTable.propsTypes = { getAllProductParts: PropTypes.func.isRequired };

var mapStateToProps = state => ({
	ProductList: state?.home?.ProductList?.response,
});

export default connect(mapStateToProps, { getAllProductParts })(
	ProductListTable
);
